// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { getSettings } from '../../helpers/data-helper';
import { PriorityHazardClustersDefaultSettings } from './widgets-default-settings';
import ClassificationTrendsBase from './ClassificationTrendsBase';
import { WidgetCode } from './widgetCodes';
import { getReportWidgetData } from '../../services/WidgetDataService';

function PriorityHazardClusters({ limit, settings }) {
  const {
    title,
    info,
    hazard,
    reportsPercent,
    previousPeriodReportsPercent,
    currentPeriodReportsPercent,
    noDataLabel,
  } = getSettings(settings, PriorityHazardClustersDefaultSettings);

  const fetchTrendsFunc = () => getReportWidgetData(WidgetCode.priorityHazards);

  return (
    <ClassificationTrendsBase
      trendsFetchFunc={fetchTrendsFunc}
      limit={limit}
      title={title}
      info={info}
      noDataLabel={noDataLabel}
      classificationType={hazard}
      previousPeriod={previousPeriodReportsPercent}
      currentPeriod={currentPeriodReportsPercent}
      reportsPercent={reportsPercent}
      widgetName="PriorityHazardClusters"
    />
  );
}

PriorityHazardClusters.propTypes = {
  limit: PropTypes.number,
  settings: PropTypes.object,
};

export default PriorityHazardClusters;
